// extracted by mini-css-extract-plugin
export default {"background":"SubirArchivo_background__Qe0pg","modal":"SubirArchivo_modal__uozKX","hr":"SubirArchivo_hr__DRQhI","form":"SubirArchivo_form__7Dw+e"};